import { render, staticRenderFns } from "./EmpresasHome.vue?vue&type=template&id=f6a7608e"
import script from "./EmpresasHome.vue?vue&type=script&lang=js"
export * from "./EmpresasHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports